const products=JSON.parse(document.querySelector('#heirloom-products').textContent);

const collections=JSON.parse(document.querySelector('#heirloom-collections').textContent);

// Keep collection membership and displayed counts aligned with product categories.
collections.forEach(group=>{const members=products.filter(p=>(p.categories||[]).includes(group.handle));if(members.length){group.handles=members.map(p=>p.handle);group.count=members.length;}});
document.querySelectorAll('.directory-card').forEach(card=>{const handle=card.getAttribute('href').split('/').pop();const group=collections.find(c=>c.handle===handle);const count=card.querySelector('.directory-card-copy p');if(group&&count)count.textContent=group.count+' products';});
if(!collections.some(c=>c.handle==='all'))collections.push({title:'All products',handle:'all',handles:products.map(p=>p.handle)});

const imageWithWidth=(src,width)=>{const url=new URL(src,location.origin);url.searchParams.set('width',String(width));return url.href;};

const base='';

const root=window.Heirloom.root;

const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:window.Heirloom.currency||'INR',maximumFractionDigits:2}).format(n);

const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

function readSaved(key,fallback){try{return JSON.parse(localStorage.getItem(key))||fallback}catch{return fallback}}

let saved=new Set();let wishlistItems=[],wishlistApi=null;const wishlistPending=new Map();let wishlistRefreshVersion=0;

function saveLocal(key,value){try{localStorage.setItem(key,JSON.stringify(value))}catch{}}

const featured=['black-pepper','cardamom-8-mm','ceylon-cinnamon','cloves','cashewnut-w180','almonds'].map(h=>products.find(p=>p.handle===h)).filter(Boolean);

function categoryBestsellers(filter){const handles={spices:'spices-and-herbs-1',nuts:'nuts-and-seeds',dry:'dry-fruits',beauty:'beauty-health-care',seasonings:'condiments'};const collection=collections.find(c=>c.handle===handles[filter]);return (collection?.handles||[]).map(h=>products.find(p=>p.handle===h)).filter(Boolean).slice(0,4);}
function renderProducts(list=categoryBestsellers('spices')){const prioritizeFirst=document.body.classList.contains('template-collection');document.querySelector('#products').innerHTML=list.map((p,index)=>{const first=Math.max(0,p.variants.findIndex(v=>v[3]));return `<article class="product"><div class="product-visual"><a class="product-image" href="/products/${p.handle}">${p.image?`<img src="${esc(imageWithWidth(p.image,600))}" srcset="${[240,400,600].map(width=>esc(imageWithWidth(p.image,width))+' '+width+'w').join(', ')}" sizes="(max-width: 700px) 45vw, 25vw" alt="${esc(p.name)}" ${prioritizeFirst&&index===0?'loading="eager" fetchpriority="high"':'loading="lazy"'} width="400" height="400">`:`<span class="no-product-photo">Product photo coming soon</span>`}</a><button class="wish-button" data-wish="${p.handle}" aria-label="Save ${esc(p.name)} to wishlist" aria-pressed="${saved.has(p.handle)}">${saved.has(p.handle)?'♥':'♡'}</button></div><p class="product-type">${esc(p.type)}</p><h3><a href="/products/${p.handle}">${esc(p.name)}</a></h3><div class="product-bottom"><select aria-label="Pack size for ${esc(p.name)}" data-handle="${p.handle}">${p.variants.map((v,i)=>`<option value="${i}" ${i===first?'selected':''} ${v[3]?'':'disabled'}>${esc(v[0]==='Default Title'?'Standard pack':v[0])}${v[3]?'':' — Sold out'}</option>`).join('')}</select><strong class="product-price">${money(p.variants[first][1])}</strong></div><p class="bag-status" data-bag-product="${p.handle}" role="status" hidden></p><button class="add-button" data-add="${p.handle}" ${p.variants.some(v=>v[3])?'':'disabled'}>${p.variants.some(v=>v[3])?'Add to bag <span aria-hidden="true">+</span>':'Sold out'}</button></article>`}).join('');syncBagIndicators();}



const cart=document.querySelector('#cart');let toastTimer;const basket=new Map();
const cartControlPending=new Set();
let cartNeedsRefresh=false;
const cartControlText=window.Heirloom.cartControls||{add:'Add to cart',inCart:'In your cart [count]',addLabel:'Add [quantity] of [product] to cart',moreLabel:'In your cart [count]. Add [quantity] more of [product]',removeLabel:'Remove one [product] from cart',soldOut:'Sold out',refreshError:'Your item was added, but the cart display could not be refreshed. Open your basket to check before adding again.',uncertainError:'The cart update could not be confirmed. Open your basket to check before trying again.'};
function cartText(key,values={}){return Object.entries(values).reduce((text,[name,value])=>text.replaceAll('['+name+']',String(value)),cartControlText[key]);}

function ensureCartControl(add){
 let control=add.closest('.cart-control');if(control)return control;
 control=document.createElement('div');control.className='cart-control';
 add.before(control);control.append(add);
 const summary=document.createElement('span');summary.className='cart-control-summary';summary.hidden=true;
 summary.innerHTML='<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3h2l2.5 12h11l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg><span class="cart-control-count"></span>';
 const status=document.createElement('span');status.className='cart-control-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');status.setAttribute('aria-atomic','true');
 control.append(summary);
 for(const [action,label] of [['minus','−'],['plus','+']]){const button=document.createElement('button');button.type='button';button.className='cart-control-'+action;button.dataset[action==='minus'?'cartMinus':'cartPlus']='';button.textContent=label;button.hidden=true;control.append(button);}
 control.append(status);return control;
}

function syncCartControl(add,id,available,name,quantity=1){
 const control=ensureCartControl(add),minus=control.querySelector('[data-cart-minus]'),plus=control.querySelector('[data-cart-plus]'),summary=control.querySelector('.cart-control-summary'),status=control.querySelector('.cart-control-status');
 id=String(id);const count=basket.get(id)||0,busy=cartControlPending.has(id),active=document.activeElement;
 if(busy&&control.contains(active)&&!control.dataset.restoreCartFocus){control.dataset.restoreCartFocus=active===minus?'minus':active===plus?'plus':'add';control.dataset.restoreCartVariant=id;}
 control.classList.toggle('is-in-cart',count>0);control.dataset.variantId=id;
 control.setAttribute('aria-busy',String(busy));
 add.disabled=!available||busy;add.hidden=count>0;
 add.textContent=busy?'Adding…':available?cartControlText.add:cartControlText.soldOut;
 add.setAttribute('aria-label',available?cartText('addLabel',{quantity,product:name}):cartControlText.soldOut);
 if(busy)add.setAttribute('aria-busy','true');else add.removeAttribute('aria-busy');
 summary.hidden=!count;summary.querySelector('.cart-control-count').textContent=String(count);
 summary.setAttribute('aria-label',cartText('inCart',{count})+' · '+name);
 status.textContent=busy?'Updating cart…':count?cartText('inCart',{count}):'';
 for(const button of [minus,plus]){button.dataset.variantId=id;button.dataset.productName=name;button.hidden=!count;button.disabled=busy||(button===plus&&!available);}
 minus.setAttribute('aria-label',cartText('removeLabel',{product:name}));
 plus.setAttribute('aria-label',cartText('moreLabel',{count,quantity:1,product:name}));
 if(!busy&&control.dataset.restoreCartFocus){const action=control.dataset.restoreCartFocus,same=control.dataset.restoreCartVariant===id;delete control.dataset.restoreCartFocus;delete control.dataset.restoreCartVariant;if(same&&(document.activeElement===document.body||control.contains(document.activeElement))){const target=count?(action==='minus'?minus:plus):add;if(!target.disabled)target.focus({preventScroll:true});}}
}

async function runCartControl(id,operation){
 id=String(id);if(cartControlPending.has(id))return;
 cartControlPending.add(id);syncBagIndicators();
 try{await operation();}catch(error){
  try{await enqueue(refreshCart);}catch{cartNeedsRefresh=true;}
  showError(error);
 }finally{cartControlPending.delete(id);syncBagIndicators();}
}

function changeOneInBasket(id,delta){return enqueue(async()=>{
 if(cartNeedsRefresh)await refreshCart();
 const line=cartData.items.find(item=>String(item.variant_id)===String(id)&&item.quantity>0);
 if(!line){if(delta>0)return addItemAndRefresh(id,1);return cartData;}
 try{cartData=await requestCart('cart/change.js',{id:line.key,quantity:line.quantity+delta});}catch(error){if(!error.cartRejected){cartNeedsRefresh=true;throw Error(cartControlText.uncertainError);}throw error;}
 updateCart();signalCart();
 if(delta>0){const added=cartData.items.find(item=>String(item.variant_id)===String(id));if(added)window.HeirloomCartNotice.show(added,1);}
 return cartData;
});}
function removeOneFromBasket(id){return changeOneInBasket(id,-1);}


let cartData=JSON.parse(document.querySelector('#heirloom-cart').textContent);

function showError(error){const t=document.querySelector('#toast');t.textContent=error.message||'Something went wrong. Please try again.';t.style.display='block';clearTimeout(toastTimer);toastTimer=setTimeout(()=>t.style.display='none',5000)}

function updateCart(){

 basket.clear();cartData.items.forEach(item=>basket.set(String(item.variant_id),(basket.get(String(item.variant_id))||0)+item.quantity));

 document.querySelector('#cart-count').textContent=cartData.item_count;

 document.querySelector('#cart-items').innerHTML=cartData.items.length?cartData.items.map(item=>`<article class="cart-line">${item.image?`<img src="${esc(item.image)}" alt="" width="70" height="70">`:''}<div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><p>${esc(item.variant_title||'Standard pack')} · ${money(item.final_price/100)}</p><div class="quantity"><div class="quantity-stepper"><button data-line="${esc(item.key)}" data-change="-1" aria-label="Decrease ${esc(item.product_title)} quantity">−</button><span>${item.quantity}</span><button data-line="${esc(item.key)}" data-change="1" aria-label="Increase ${esc(item.product_title)} quantity">+</button></div><button data-remove="${esc(item.key)}" class="remove">Remove</button></div></div><strong>${money(item.final_line_price/100)}</strong></article>`).join(''):'<div class="empty-cart"><h3>A little room for flavour.</h3><p>Your basket is empty. Explore our favourites to get started.</p><button class="button" id="continue-shopping">Keep exploring</button></div>';

 document.querySelector('#cart-summary').innerHTML=cartData.items.length?`<div class="cart-total"><span>Subtotal</span><strong>${money(cartData.total_price/100)}</strong></div><p class="shipping-note">Delivery ₹180 on orders below ₹2,499. Free delivery on orders ₹2,499 and above.</p><p class="checkout-note return-summary">Damaged, defective or incorrect item? Contact us with your order number and details of the issue. We will let you know if further information is needed. Opening the product does not by itself make a genuine claim ineligible. Refunds or replacements are subject to review. <a href="https://heirloomspices.in/pages/return-refund-policy" style="text-decoration:underline">Read our return &amp; refund policy</a></p><p class="checkout-note">Taxes and delivery calculated at checkout.</p><form action="${root}cart" method="post"><button class="button checkout" name="checkout" type="submit">Checkout <span>↗</span></button></form><a class="text-link" href="${root}cart">View full basket</a>`:'';

 syncBagIndicators();

}

async function requestCart(path,body){

 const response=await fetch(root+path,{signal:AbortSignal.timeout(12000),method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});

 const data=await response.json();if(!response.ok){const error=Error(data.description||data.message||'Unable to update your basket');error.cartRejected=true;throw error;}return data;

}

let queue=Promise.resolve();

function enqueue(operation){const result=queue.then(operation);queue=result.catch(()=>{});return result;}

async function refreshCart(){cartData=await requestCart('cart.js');cartNeedsRefresh=false;updateCart();return cartData;}

function signalCart(){try{localStorage.setItem('heirloom-cart-updated',String(Date.now()))}catch{}}

async function addItemAndRefresh(id,quantity){
 if(!Number.isInteger(quantity)||quantity<1||quantity>99)throw Error('Choose a quantity between 1 and 99.');
 let added;
 try{added=await requestCart('cart/add.js',{items:[{id:String(id),quantity}]});}catch(error){if(!error.cartRejected){cartNeedsRefresh=true;throw Error(cartControlText.uncertainError);}throw error;}
 signalCart();
 try{await refreshCart();}catch{cartNeedsRefresh=true;throw Error(cartControlText.refreshError);}
 window.HeirloomCartNotice.show(added.items[0],quantity);return cartData;
}
function addToBasket(id,quantity=1){return enqueue(async()=>{
 if(cartNeedsRefresh)await refreshCart();
 return addItemAndRefresh(id,quantity);
});}

document.querySelector('#cart-open').addEventListener('click',async e=>{e.preventDefault();if(!cart.open)cart.showModal();try{await enqueue(refreshCart)}catch(error){showError(error)}});

document.querySelector('#cart-close').addEventListener('click',()=>cart.close());

cart.addEventListener('click',e=>{if(e.target===cart){const r=cart.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)cart.close()}});

document.addEventListener('change',e=>{const select=e.target.closest('select[data-handle]');if(!select)return;const p=products.find(p=>p.handle===select.dataset.handle);select.closest('.product').querySelector('.product-price').textContent=money(p.variants[Number(select.value)][1]);syncBagIndicators()});

document.addEventListener('click',async e=>{

 const plus=e.target.closest('[data-cart-plus]');if(plus){if(plus.disabled)return;const id=plus.dataset.variantId;await runCartControl(id,()=>changeOneInBasket(id,1));return;}
 const minus=e.target.closest('[data-cart-minus]');if(minus){if(minus.disabled)return;const id=minus.dataset.variantId;await runCartControl(id,()=>removeOneFromBasket(id));return;}
 const add=e.target.closest('[data-add]');if(add){if(add.disabled)return;const p=products.find(p=>p.handle===add.dataset.add);const selected=p?.variants[Number(add.closest('.product').querySelector('select').value)];if(!selected?.[3])return;const id=String(selected[2]);await runCartControl(id,()=>addToBasket(id));return;}

 const change=e.target.closest('[data-line],[data-remove]');if(change){change.disabled=true;try{await enqueue(async()=>{if(cartNeedsRefresh)await refreshCart();const key=change.dataset.line||change.dataset.remove;const line=cartData.items.find(item=>item.key===key);if(!line)return;try{cartData=await requestCart('cart/change.js',{id:key,quantity:change.dataset.remove?0:Math.max(0,line.quantity+Number(change.dataset.change))});}catch(error){if(!error.cartRejected)cartNeedsRefresh=true;throw error;}updateCart();signalCart()})}catch(error){showError(error)}finally{change.disabled=false}}

 if(e.target.closest('#continue-shopping'))cart.close();

 const filter=e.target.closest('[data-filter]');if(filter){document.querySelectorAll('[data-filter]').forEach(b=>{b.classList.toggle('active',b===filter);b.setAttribute('aria-pressed',String(b===filter))});renderProducts(filter.dataset.filter==='all'?featured:categoryBestsellers(filter.dataset.filter));updateWishlist()}

});

document.querySelector('#menu-toggle').addEventListener('click',e=>{const open=document.querySelector('#navigation').classList.toggle('open');e.currentTarget.setAttribute('aria-expanded',String(open))});

const searchInput=document.querySelector('.search input[type="search"]');const suggestions=document.createElement('div');suggestions.className='search-suggestions';suggestions.hidden=true;document.querySelector('.search').append(suggestions);searchInput.setAttribute('aria-controls','search-suggestions');suggestions.id='search-suggestions';

searchInput.addEventListener('input',()=>{const q=searchInput.value.trim().toLowerCase();if(!q){suggestions.hidden=true;return}const alias={elaichi:'cardamom',elakka:'cardamom',kurumulaku:'pepper',dalchini:'cinnamon',laung:'cloves',badam:'almonds',kaju:'cashew'};const term=alias[q]||q;const matches=products.filter(p=>p.name.toLowerCase().includes(term));suggestions.innerHTML=matches.slice(0,8).map(p=>`<a href="/products/${p.handle}">${p.image?`<img src="${p.image}&width=80" alt="" width="40" height="40">`:""}<span>${p.name}<small>From ${money(p.variants[0][1])}</small></span></a>`).join('')+`<a class="all-results" href="/search?q=${encodeURIComponent(term)}">${matches.length?'Search the full store':'Search all products in our store'} ↗</a>`;suggestions.hidden=false});document.addEventListener('click',e=>{if(!e.target.closest('.search'))suggestions.hidden=true});searchInput.addEventListener('keydown',e=>{if(e.key==='Escape')suggestions.hidden=true});

function wishlistProduct(button){

 const p=products.find(item=>item.handle===button.dataset.wish);if(!p)return null;

 const card=button.closest('.product');

 const selected=card?.querySelector('select');

 const variant=button.classList.contains('pdp-wish')?p.variants.find(v=>v[2]===document.querySelector('#native-variant')?.value):p.variants[Number(selected?.value||0)];

 const v=variant||p.variants.find(item=>item[3])||p.variants[0];

 return {empi:Number(p.id),epi:Number(v[2]),du:new URL('/products/'+p.handle,location.origin).href,dt:p.name,iu:p.image,pr:v[1]};

}

function wishlisted(product){return product&&wishlistItems.some(item=>String(item.epi)===String(product.epi)&&String(item.empi)===String(product.empi));}

function updateWishlist(){

 document.querySelector('#wishlist-count').textContent=wishlistItems.length;

 document.querySelectorAll('[data-wish]').forEach(button=>{

  const product=wishlistProduct(button),active=wishlisted(product);

  button.setAttribute('aria-pressed',String(active));button.textContent=active?'♥':'♡';

  button.setAttribute('aria-label',(active?'Remove ':'Save ')+(product?.dt||button.dataset.wish)+(active?' from wishlist':' to wishlist'));

  button.disabled=wishlistPending.has(String(product?.epi));

 });

}

function setWishlistProduct(product,active){
 wishlistItems=wishlistItems.filter(item=>!(String(item.epi)===String(product.epi)&&String(item.empi)===String(product.empi)));
 if(active)wishlistItems.push(product);
}
function refreshWishlist(){
 if(!wishlistApi)return;
 const version=++wishlistRefreshVersion;
 wishlistApi.fetch(items=>{if(version!==wishlistRefreshVersion)return;wishlistItems=Array.isArray(items)?items:[];wishlistPending.forEach(({product,active})=>setWishlistProduct(product,active));saved=new Set(wishlistItems.map(item=>{try{return new URL(item.du,location.origin).pathname.split('/products/')[1]?.split('/')[0]}catch{return null}}).filter(Boolean));updateWishlist();});
}
function changeWishlist(product,remove){

 return new Promise((resolve,reject)=>{

  const timeout=setTimeout(()=>reject(new Error(window.Heirloom.wishlist.timeout)),20000);

  const done=value=>{clearTimeout(timeout);resolve(value)};

  const failed=()=>{clearTimeout(timeout);reject(new Error(window.Heirloom.wishlist.error))};

  try{wishlistApi[remove?'removeFromWishList':'addToWishList'](product,done,failed)}catch(error){clearTimeout(timeout);reject(error)}

 });

}

document.addEventListener('click',async event=>{

 const button=event.target.closest('[data-wish]');if(!button)return;

 if(!wishlistApi){showError(new Error(window.Heirloom.wishlist.loading));return;}

 const product=wishlistProduct(button);if(!product||wishlistPending.has(String(product.epi)))return;

 const remove=wishlisted(product);const previous=wishlistItems.find(item=>String(item.epi)===String(product.epi)&&String(item.empi)===String(product.empi));wishlistRefreshVersion++;wishlistPending.set(String(product.epi),{product,active:!remove});setWishlistProduct(product,!remove);updateWishlist();

 try{await changeWishlist(product,remove);const toast=document.querySelector('#toast');toast.textContent=remove?window.Heirloom.wishlist.removed:window.Heirloom.wishlist.saved;toast.style.display='block';clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.style.display='none',2200)}catch(error){setWishlistProduct(previous||product,remove);showError(error)}finally{wishlistRefreshVersion++;wishlistPending.delete(String(product.epi));updateWishlist();refreshWishlist()}

});

document.addEventListener('change',event=>{if(event.target.matches('.product select'))updateWishlist()});

window.SwymCallbacks=window.SwymCallbacks||[];

window.SwymCallbacks.push(function(swat){

 wishlistApi=swat;refreshWishlist();

 if(swat.evtLayer){['sw:addedtowishlist','sw:removedfromwishlist'].forEach(name=>swat.evtLayer.addEventListener(name,refreshWishlist));}

});

function offerWishlistImport(){

 const local=readSaved('heirloom-wishlist',[]);if(!Array.isArray(local)||!local.length||!location.pathname.endsWith('/pages/swym-wishlist'))return;

 const box=document.createElement('div');box.className='wrap wishlist-import';

 const button=document.createElement('button');button.className='button';button.textContent=window.Heirloom.wishlist.import;box.append(button);

 document.querySelector('#shopify-section-heirloom-header').after(box);

 button.addEventListener('click',async()=>{

  if(!wishlistApi){showError(new Error(window.Heirloom.wishlist.loading));return;}

  button.disabled=true;

  try{for(const handle of readSaved('heirloom-wishlist',[])){

   const product=products.find(p=>p.handle===handle);if(!product)continue;

   const variant=product.variants.find(v=>v[3])||product.variants[0];

   const item={empi:Number(product.id),epi:Number(variant[2]),du:new URL('/products/'+handle,location.origin).href,dt:product.name,iu:product.image,pr:variant[1]};

   if(!wishlisted(item))await changeWishlist(item,false);

   saveLocal('heirloom-wishlist',readSaved('heirloom-wishlist',[]).filter(h=>h!==handle));

  }location.reload()}catch(error){showError(error);button.disabled=false}

 });

}

offerWishlistImport();

window.addEventListener('focus',refreshWishlist);

updateWishlist();



function syncBagIndicators(){

 document.querySelectorAll('[data-bag-product]').forEach(status=>{

  const p=products.find(p=>p.handle===status.dataset.bagProduct);if(!p)return;

  const lines=p.variants.filter(v=>basket.get(String(v[2]))>0);

  status.hidden=!lines.length;

  status.textContent=lines.length?'In your bag · '+lines.map(v=>(v[0]==='Default Title'?'Standard pack':v[0])+' × '+basket.get(String(v[2]))).join(' · '):'';

  const card=status.closest('.product');if(card){card.classList.toggle('is-in-bag',!!lines.length);const select=card.querySelector('select');[...select.options].forEach((option,index)=>{const variant=p.variants[index];option.disabled=!variant[3]&&!basket.get(String(variant[2]));});const selected=p.variants[Number(select.value)];syncCartControl(card.querySelector('[data-add]'),selected[2],selected[3],p.name+' · '+(selected[0]==='Default Title'?'Standard pack':selected[0]));}

 });

 const detailAdd=document.querySelector('#detail-add');
 if(detailAdd?.dataset.variantId){const data=JSON.parse(document.querySelector('#product-data').textContent),variant=data.variants.find(v=>String(v.id)===detailAdd.dataset.variantId);document.querySelectorAll('[data-pack]').forEach(button=>{const pack=data.variants[Number(button.dataset.pack)];button.disabled=!pack.available&&!basket.get(String(pack.id));});if(variant){const product=products.find(p=>p.handle===data.handle),quantity=Math.max(1,Math.min(99,Number(document.querySelector('#detail-quantity').value)||1));syncCartControl(detailAdd,variant.id,variant.available,(product?.name||data.handle)+' · '+(variant.label==='Default Title'?'Standard pack':variant.label),quantity);}}

}



updateCart();

window.addEventListener('storage',e=>{if(e.key==='heirloom-cart-updated'||e.key===null){cartNeedsRefresh=true;enqueue(refreshCart).catch(showError);}});

window.addEventListener('pageshow',e=>{if(e.persisted){cartNeedsRefresh=true;enqueue(refreshCart).catch(showError)}});

document.addEventListener('visibilitychange',()=>{if(!document.hidden){cartNeedsRefresh=true;enqueue(refreshCart).catch(showError);refreshWishlist()}});


